import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
  }

  connect() {
    //console.log("Modalmaster")
  }
  
  disconnect() {
  }

  showModal(event) {
    event.preventDefault();
    //console.log("modalmaster#showModal");
    const origin = event.target.getAttribute('data-target');
    let modalId = event.target.getAttribute('data-target');
    //console.log("origin", origin);
    if (modalId == "brief" || modalId == "wpi" || modalId == "wpipremium" || modalId == "paketpremium") {
      modalId = "other";
    }
    //console.log("modalID", modalId);
    // ID des Formulars der angeklickten Versandoption - das Modal schickt
    // genau dieses Formular ab (nicht das erste Formular der Gruppe).
    const formId = event.target.getAttribute('data-form-id');
    EventTarget.prototype.dispatchEvent.call(window, new CustomEvent("show-modal", {detail: [modalId, origin, formId]}));
  }
}
